/**
 * Org Param Groups — registration entry point.
 *
 * Call `registerOrgParamGroups()` once during bootstrap (alongside
 * `registerManifests()` in `data-access.bootstrap.ts`).
 *
 * To add a new group: create a new `*.orgParamGroup.ts` file, import it here,
 * and add `orgParamGroupRegistry.register(newGroup)`. No other changes needed.
 */
import { orgParamGroupRegistry } from '../services/orgParamGroupRegistry.js';
import { stockOrgParamGroup } from './stock.orgParamGroup.js';
import { displayOrgParamGroup } from './display.orgParamGroup.js';
import { productionOrgParamGroup } from './production.orgParamGroup.js';
import { invoiceOrgParamGroup } from './invoice.orgParamGroup.js';
export function registerOrgParamGroups() {
    orgParamGroupRegistry.register(stockOrgParamGroup);
    orgParamGroupRegistry.register(displayOrgParamGroup);
    orgParamGroupRegistry.register(productionOrgParamGroup);
    orgParamGroupRegistry.register(invoiceOrgParamGroup);
}
//# sourceMappingURL=index.js.map